import * as React from "react";
import {
  DateElement,
  HeadlineSticky,
  IconPrint,
  KudosItem,
  PrintOption,
  PrintOptionItem,
  RemoveKudos,
  ShowMore,
  TextKudos,
  Vote,
  VoteNumber,
  WraperVote,
} from "./KudosListStyled";

import * as moment from "moment";
import KudosContext from "src/context";
import { showFile } from "src/services/showFile";

interface State {
  pageCounter: number;
}

export class KudosListComponent extends React.Component<{}, State> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public readonly state = {
    pageCounter: 1,
  };

  public componentDidMount() {
    this.context!.fetchKudos();
  }

  public render() {
    const lastPage: boolean =
      this.context && this.context.kudos ? this.context.kudos.last_page : false;
    return (
      <>
        <HeadlineSticky>
          Activity stream
          <IconPrint>
            <PrintOption>
              <PrintOptionItem onClick={() => this.print("week")}>
                Print last week
              </PrintOptionItem>
              <PrintOptionItem onClick={() => this.print("month")}>
                Print last month
              </PrintOptionItem>
            </PrintOption>
          </IconPrint>
        </HeadlineSticky>
        {this.renderKudos()}
        <ShowMore
          disabled={lastPage}
          inProgress={
            this.context && this.context.fetchingKudosInProgress
              ? this.context.fetchingKudosInProgress
              : false
          }
          revers={true}
          centered={true}
          hide={
            !(!!this.context!.kudos && this.context!.kudos!.kudos.length > 0)
          }
          onClick={this.showMore}
        >
          Show more
        </ShowMore>
      </>
    );
  }

  private print = (range: string) => {
    this.context!.setSpinner(true);
    this.context!.createPdf(range).then((blob: Blob) => {
      this.context!.setSpinner(false);
      showFile(blob);
    });
  };

  private showMore = () => {
    this.setState({
      pageCounter: (this.state.pageCounter = this.state.pageCounter + 1),
    });
    this.context!.setFetchingKudosProgressStatus(true);
    if (this.context) {
      this.context.fetchKudos(this.state.pageCounter);
    }
  };

  private renderKudos = (): JSX.Element[] | null => {
    const { kudos } = this.context!;

    return kudos
      ? kudos.kudos.map((k) => {
          return (
            <KudosItem key={Math.random()}>
              <DateElement>{moment(k.timestamp).fromNow()}</DateElement>
              <TextKudos dangerouslySetInnerHTML={{ __html: k.description }} />
              <WraperVote>
                <VoteNumber>{k.vote.votes_number}</VoteNumber>
                <Vote
                  fiilled={k.vote.has_been_voted}
                  onClick={() => this.vote(k.id)}
                />
                <RemoveKudos
                  show={this.context!.profile!.admin!}
                  onClick={() =>
                    this.context!.removeKudos(k.id, this.state.pageCounter)
                  }
                />
              </WraperVote>
            </KudosItem>
          );
        })
      : null;
  };

  private vote = (id: string) =>
    this.context!.voteForKudos(id, this.state.pageCounter);
}
